import { Link } from "react-router-dom";
import { Gem } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-[#D4AF37]/15 bg-[#0A0A0E]">
      <div className="h-px shimmer-line" />
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="grid place-items-center w-8 h-8 border border-[#D4AF37]/50 rotate-45">
              <Gem className="w-4 h-4 text-[#D4AF37] -rotate-45" />
            </span>
            <span className="font-serif-sc font-bold text-lg tracking-widest">合赢项目交流社区</span>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed">
            汇聚项目资源，连接可靠项目。合赢项目交流社区致力于为成员提供可靠、零风险的赚钱项目。
          </p>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] text-[#D4AF37] mb-5">快速导航</p>
          <div className="flex flex-col gap-3 text-sm text-gray-400">
            <Link to="/" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-home-link">首页</Link>
            <Link to="/invite" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-invite-link">邀请大厅</Link>
            <Link to="/me" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-me-link">个人中心</Link>
          </div>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] text-[#D4AF37] mb-5">加入方式</p>
          <p className="text-sm text-gray-500 leading-relaxed">
            会员资格通过卡密激活。卡密可在淘宝搜索「合赢项目交流社区」购买，激活后即可获得专属邀请码与邀请奖励资格。
          </p>
        </div>
      </div>
      <div className="border-t border-[#D4AF37]/10 py-6 text-center text-xs text-gray-600 tracking-widest">
        © 2026 合赢项目交流社区 · HEYING PROJECT EXCHANGE COMMUNITY
      </div>
    </footer>
  );
}
